/**
 * Simple test page to verify WebApp is working
 */
import React from 'react';

function TestPage() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#111827', 
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>HotBump Web App</h1>
      <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>Web App is working!</p>
      <div style={{ backgroundColor: '#1f2937', padding: '1rem', borderRadius: '0.5rem' }}>
        <p>If you see this page, React is rendering correctly.</p>
        <p>Current URL: {window.location.pathname}</p>
        <p>Time: {new Date().toLocaleString()}</p>
      </div>
    </div>
  );
}

export default TestPage;

